// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthButton_container__R9ONM","primary":"AuthButton_primary__B1VZf"};